import i18next from 'i18next';

async function loadTranslationsForFolder(folder: string, language: string) {
  const translationModule = await import(`../features/${folder}/locales/${language}/${folder}.yml`);

  return translationModule.default;
}

export function loadTranslations(folders: Array<string>, language: string) {
  const promises = folders.map((folder) => {
    return loadTranslationsForFolder(folder, language)
      .then((translations) => {
        i18next.addResourceBundle(language, folder, translations);
      })
      .catch(() => {});
  });
  return Promise.all(promises);
}

export async function loadSharedTranslations(language: string) {
  const sharedTranslationModule = await import(`../shared/locales/${language}/shared.yml`);

  i18next.addResourceBundle(language, 'shared', sharedTranslationModule.default);
}
